module.exports = __webpack_public_path__ + "img/passport.6f167dd6.png";